import{__exports as e}from"../../../../../_virtual/master-copies.js";Object.defineProperty(e,"__esModule",{value:!0});export{e as default};
